import React from "react";
import Header from "./Header";
import "../css/video.css";
import Footer from "./Footer";
function video() {
  return (
    <div className="mv">
      {" "}
      <Header></Header>
      <div className="section0">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4> Video Production Services</h4>
              <p>Use the power of video to wow your audience.</p>
              <a href="/#" className="btn btn-outline-success">
                GET MY FREE PROPOSAL
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="vi">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <iframe
                data-aos="zoom-out-down"
                src="https://www.youtube.com/embed/H-2ddhMO0eU?si=OoNxXTBAeF49CaFY"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
            <div className="col-12">
              <h1>Delivering high-quality video content</h1>
              <p>
                Elevate your digital marketing efforts by leveraging the power
                of video. We are a Dallas-based video production company that
                delivers high-quality video content from start to finish. Our
                in-house production team can produce, storyboard, direct and
                edit the most captivating visual experience to 'wow' your
                audience - every time.
              </p>
              <h1>Why choose us for your next video project?</h1>
              <p>
                Elevate your digital marketing efforts by leveraging the power
                of video. We are a Dallas-based video production company that
                delivers high-quality video content from start to finish. Our
                in-house production team can produce, storyboard, direct and
                edit the most captivating visual experience to 'wow' your
                audience - every time.
              </p>
              <hr />
            </div>
          </div>
        </div>
      </div>
      <div className="videos">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>What kind of video do you need?</h1>
              <p>
                "Humans are incredibly visual; and powerful moving images help
                us find meaning, and video helps capture and contextualize the
                world around us." - Dan Patterson
              </p>
            </div>
            <div className="col-md-6" data-aos="fade-up">
              <div className="vid">
                <iframe
                  src="https://www.youtube.com/embed/H-2ddhMO0eU?si=OoNxXTBAeF49CaFY"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
                <p>
                  <b>ABOUT US | BRAND</b> <br />
                  What’s your story? Every business has a unique identity. Give
                  your customers a behind-the-scenes look at your best
                  practices, mission statement, and persona. A brand video is
                  the best way to connect your audience to your message.
                </p>
              </div>
            </div>

            <div className="col-md-6" data-aos="fade-up">
              <div className="vid">
                <iframe
                  src="https://www.youtube.com/embed/H-2ddhMO0eU?si=OoNxXTBAeF49CaFY"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
                <p>
                  <b>ABOUT US | BRAND</b> <br />
                  What’s your story? Every business has a unique identity. Give
                  your customers a behind-the-scenes look at your best
                  practices, mission statement, and persona. A brand video is
                  the best way to connect your audience to your message.
                </p>
              </div>
            </div>

            <div className="col-md-6" data-aos="fade-up">
              <div className="vid">
                <iframe
                  src="https://www.youtube.com/embed/H-2ddhMO0eU?si=OoNxXTBAeF49CaFY"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
                <p>
                  <b>ABOUT US | BRAND</b> <br />
                  What’s your story? Every business has a unique identity. Give
                  your customers a behind-the-scenes look at your best
                  practices, mission statement, and persona. A brand video is
                  the best way to connect your audience to your message.
                </p>
              </div>
            </div>

            <div className="col-md-6" data-aos="fade-up">
              <div className="vid">
                <iframe
                  src="https://www.youtube.com/embed/H-2ddhMO0eU?si=OoNxXTBAeF49CaFY"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
                <p>
                  <b>ABOUT US | BRAND</b> <br />
                  What’s your story? Every business has a unique identity. Give
                  your customers a behind-the-scenes look at your best
                  practices, mission statement, and persona. A brand video is
                  the best way to connect your audience to your message.
                </p>
              </div>
            </div>

            <div className="col-md-6" data-aos="fade-up">
              <div className="vid">
                <iframe
                  src="https://www.youtube.com/embed/H-2ddhMO0eU?si=OoNxXTBAeF49CaFY"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
                <p>
                  <b>ABOUT US | BRAND</b> <br />
                  What’s your story? Every business has a unique identity. Give
                  your customers a behind-the-scenes look at your best
                  practices, mission statement, and persona. A brand video is
                  the best way to connect your audience to your message.
                </p>
              </div>
            </div>

            <div className="col-md-6" data-aos="fade-up">
              <div className="vid">
                <iframe
                  src="https://www.youtube.com/embed/H-2ddhMO0eU?si=OoNxXTBAeF49CaFY"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
                <p>
                  <b>ABOUT US | BRAND</b> <br />
                  What’s your story? Every business has a unique identity. Give
                  your customers a behind-the-scenes look at your best
                  practices, mission statement, and persona. A brand video is
                  the best way to connect your audience to your message.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="break">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>Video production services breakdown</h1>
            </div>
            <div className="col-sm-2">
              <i class="fa-brands fa-windows"></i>
            </div>
            <div className="col-sm-10">
              <p>
                <b>PRE-PRODUCTION</b>
                <br />
                Pre-production is a crucial phase of the production process. It
                demands careful planning and preparation. We never go to a video
                shoot before we have a detailed schedule and know precisely what
                footage to capture. This is when we iron out the details and
                ensure an easy, consistent, and cost effective shoot.
              </p>
            </div>
            <div className="col-sm-2">
              <i class="fa-brands fa-windows"></i>
            </div>
            <div className="col-sm-10">
              <p>
                <b>PRE-PRODUCTION</b>
                <br />
                Pre-production is a crucial phase of the production process. It
                demands careful planning and preparation. We never go to a video
                shoot before we have a detailed schedule and know precisely what
                footage to capture. This is when we iron out the details and
                ensure an easy, consistent, and cost effective shoot.
              </p>
            </div>
            <div className="col-sm-2">
              <i class="fa-brands fa-windows"></i>
            </div>
            <div className="col-sm-10">
              <p>
                <b>PRE-PRODUCTION</b>
                <br />
                Pre-production is a crucial phase of the production process. It
                demands careful planning and preparation. We never go to a video
                shoot before we have a detailed schedule and know precisely what
                footage to capture. This is when we iron out the details and
                ensure an easy, consistent, and cost effective shoot.
              </p>
            </div>
            <div className="col-sm-2">
              <i class="fa-brands fa-windows"></i>
            </div>
            <div className="col-sm-10">
              <p>
                <b>PRE-PRODUCTION</b>
                <br />
                Pre-production is a crucial phase of the production process. It
                demands careful planning and preparation. We never go to a video
                shoot before we have a detailed schedule and know precisely what
                footage to capture. This is when we iron out the details and
                ensure an easy, consistent, and cost effective shoot.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="vidd">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <img
                src="https://thriveagency.com/files/awardimage2022-1-1.jpeg"
                alt=""
              />
            </div>
            <div className="col-12">
              <h1>A professional video agency that delivers</h1>
              <p>
                Are you looking for help with a single video project or an
                entire marketing strategy? Contact Thrive today for creative
                video marketing services and technical solutions that will
                provide real, measurable results.
              </p>
              <a href="/#" className="btn btn-outline-success">
                LET'S TALK
              </a>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default video;
